import { defineMessages } from "react-intl";

export const scope = "components.HisotryDetailsDeposit";

export const messages = defineMessages({
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: "Recibiste",
  },
  copySuccess: {
    id: `${scope}.copySuccess`,
    defaultMessage: "Copiado con exito",
  },

  statusInProgress: {
    id: `${scope}.statusInProgress`,
    defaultMessage: "Pendiente",
  },
  statusFailed: {
    id: `${scope}.statusFailed`,
    defaultMessage: "Falló",
  },
  statusOk: {
    id: `${scope}.statusOk`,
    defaultMessage: "Finalizado",
  },

  to: {
    id: `${scope}.to`,
    defaultMessage: "Destinatario",
  },

  sent: {
    id: `${scope}.sent`,
    defaultMessage: "Enviado",
  },

  fee: {
    id: `${scope}.fee`,
    defaultMessage: "Comisión",
  },

  received: {
    id: `${scope}.received`,
    defaultMessage: "Recibido",
  },

  status: {
    id: `${scope}.status`,
    defaultMessage: "Estado",
  },

  price: {
    id: `${scope}.price`,
    defaultMessage: "Cotización",
  },

  earned: {
    id: `${scope}.earned`,
    defaultMessage: "Generado",
  },

  movementId: {
    id: `${scope}.movementId`,
    defaultMessage: "Id de movimiento",
  },

  txId: {
    id: `${scope}.txId`,
    defaultMessage: "TxID",
  },

  coinDepositWarning: {
    id: `${scope}.coinDepositWarning`,
    defaultMessage:
      "Tu deposito se acreditará luego{br}de la confirmación número {confirmations}",
  },

  loadingTid: {
    id: `${scope}.loadingTid`,
    defaultMessage: "Cargando...",
  },

  copy: {
    id: `${scope}.copy`,
    defaultMessage: "Copiar",
  },
  seeMore: {
    id: `${scope}.seeMore`,
    defaultMessage: "Examinar",
  },

  amount: {
    id: `${scope}.amount`,
    defaultMessage: "Monto total",
  },
  adjustmentAmount: {
    id: `${scope}.adjustmentAmount`,
    defaultMessage: "Monto",
  },
  purchaseAmount: {
    id: `${scope}.purchaseAmount`,
    defaultMessage: "Monto de la compra",
  },
  cardFee: {
    id: `${scope}.cardFee`,
    defaultMessage: "Costo de servicio",
  },
  card: {
    id: `${scope}.card`,
    defaultMessage: "Tarjeta",
  },
  stablishment: {
    id: `${scope}.stablishment`,
    defaultMessage: "Establecimiento",
  },
  sector: {
    id: `${scope}.sector`,
    defaultMessage: "Rubro",
  },
  where: {
    id: `${scope}.where`,
    defaultMessage: "en",
  },
  approved: {
    id: `${scope}.approved`,
    defaultMessage: "Aprobado",
  },
  rejected: {
    id: `${scope}.rejected`,
    defaultMessage: "Rechazado",
  },
  details: {
    id: `${scope}.details`,
    defaultMessage: "Detalle",
  },
  cvu: {
    id: `${scope}.cvu`,
    defaultMessage: "CBU/CVU",
  },
  cuil: {
    id: `${scope}.cuil`,
    defaultMessage: "CUIL",
  },
  seeTicket: {
    id: `${scope}.seeTicket`,
    defaultMessage: "VER COMPROBANTE",
  },
  origin: {
    id: `${scope}.origin`,
    defaultMessage: "Origen",
  },
  autoswap: {
    id: `${scope}.autoswap`,
    defaultMessage: "Autoswap",
  },
  event: {
    id: `${scope}.event`,
    defaultMessage: "Evento",
  },
  autoswapDeposit: {
    id: `${scope}.autoswapDeposit`,
    defaultMessage: "Deposito de",
  },
  autoswapChasback: {
    id: `${scope}.autoswapChasback`,
    defaultMessage: "Chasback de",
  },
  autoswapInvest: {
    id: `${scope}.autoswapInvest`,
    defaultMessage: "Inversion de",
  },
  convertTo: {
    id: `${scope}.convertTo`,
    defaultMessage: "Convertir a",
  },
  convertedTo: {
    id: `${scope}.convertedTo`,
    defaultMessage: "Convertido a",
  },
  coelsaId: {
    id: `${scope}.coelsaId`,
    defaultMessage: "Coelsa ID",
  },
  generating: {
    id: `${scope}.generating`,
    defaultMessage: "Generando",
  },
  youPay: {
    id: `${scope}.youPay`,
    defaultMessage: "Pagaste",
  },
  alias: {
    id: `${scope}.alias`,
    defaultMessage: "Alias",
  },
  currencyUsed: {
    id: `${scope}.currencyUsed`,
    defaultMessage: "Saldo utilizado",
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: "Fecha",
  },
  transactionNumber: {
    id: `${scope}.transactionNumber`,
    defaultMessage: "N° transacción",
  },
  controlNumber: {
    id: `${scope}.controlNumber`,
    defaultMessage: "N° control",
  },
  noDate: {
    id: `${scope}.noDate`,
    defaultMessage: "Sin vencimiento",
  },
  shareProofOfPayment: {
    id: `${scope}.shareProofOfPayment`,
    defaultMessage: "COMPARTIR COMPROBANTE",
  },
  withholding: {
    id: `${scope}.withholding`,
    defaultMessage: "Retenciones",
  },
  retainedWithholding: {
    id: `${scope}.retainedWithholding`,
    defaultMessage: "Retenido",
  },
  baseWithholding: {
    id: `${scope}.baseWithholding`,
    defaultMessage: "Base imponible",
  },
  aliWithholding: {
    id: `${scope}.aliWithholding`,
    defaultMessage: "Alicuota",
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: "Descripcion",
  },
});
